








import { Component, Vue } from 'vue-property-decorator';
import UserService from '@/services/user';

@Component
export default class App extends Vue {
  userService = new UserService();

  authCheck: boolean = null;

  get pageClass(): string {
    return this.$route?.name?.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase().substr(1);
  }

  mounted() {
    this.userService
      .current()
      .then(() => {
        this.authCheck = true;
      })
      .catch(() => {
        this.authCheck = false;
        if (this.$route.name !== 'Login') {
          // this.$router.replace({ name: 'Login' });
        }
      });
  }
}
